subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
  const cartTotal = event?.cartData?.items_subtotal_price 
    ? event.cartData.items_subtotal_price / 100 
    : 0;
  if(cartTotal > 0){
    updateFreeShipping_drawer(cartTotal);
  }else{
    refreshCartTotal();
  }
});
async function refreshCartTotal() {
  try {
    const res = await fetch("/cart.js");
    const cart = await res.json();
    const cartTotal = cart.items_subtotal_price / 100;
    updateFreeShipping_drawer(cartTotal);
  } catch (err) {
    console.error("Cart fetch failed:", err);
  }
}

function updateFreeShipping_drawer(cartTotal) {
  const achivement_message = document.querySelector("#free-shiping-achivement-message");
  const fill = document.querySelector("#free-shipping-fill-drawer");
  const messageBox = document.querySelector("#free-shipping-message-drawer");
  const freeShippingThresholdInput = document.querySelector("#free-shipping-threshold-drawer");
  const freeShippingThreshold = freeShippingThresholdInput 
    ? freeShippingThresholdInput.value
    : 90;

  if (!fill || !messageBox) return;

  // Calculate percentage progress
  let percent = Math.min((cartTotal / freeShippingThreshold) * 100, 100);
  fill.style.width = percent + "%";

  // Change color dynamically based on percent
  if (percent < 40) {
    fill.style.background = "#f44336"; // Red
  } else if (percent < 80) {
    fill.style.background = "#ff9800"; // Orange
  } else {
    fill.style.background = "#4caf50"; // Green
  }

  // Message text
  if (cartTotal >= freeShippingThreshold) {
    messageBox.textContent = achivement_message.value;
  } else {
    const remaining = (freeShippingThreshold - cartTotal).toFixed(2);
    messageBox.textContent = `Add $${remaining} more to get Free Shipping.`;
  }
}

// Run on page load
window.addEventListener("load", async function () {
  try {
    const response = await fetch("/cart.js");
    const cartData = await response.json();
    const cartTotal = cartData.items_subtotal_price / 100; // convert cents → ₹
    updateFreeShipping_drawer(cartTotal, 90); // free shipping threshold = 90
  } catch (error) {
    console.error("Error fetching cart:", error);
  }
});
